/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useEffect, useState} from "react";
import {ToolbarItem} from "./ToolbarItem";
import {useSelector} from "react-redux";
import {service as SurveyService} from "../../../Services/SurveyService";

export const SurveyToolbarItem = (props) => {
    
    const {
        code
    } = props;
    
    const {conservationAction: conservationActionId = null} = useSelector(state => state.contextState.context);
    const [surveyTypes, setSurveyTypes] = useState([]);
    
    useEffect(() => {
        if (conservationActionId && conservationActionId !== 'new') {
            Promise.all([
                // TODO: SB-3029 - This should be a single call to the API
                // consider using CachedBaseService or adding the
                // published surveys to the ContextNodeService response?
                SurveyService.GetPublishedSurveyTypeCodesByConservationActionId(conservationActionId)
            ]).then(([surveyTypes]) => {
                setSurveyTypes(surveyTypes?.result ?? []);
            });
        }
    }, [conservationActionId]);
    
    const surveyTypeIsValidForContext =  !!(surveyTypes.find(survey => survey?.code === code));
    
    return <ToolbarItem {...{
            ...props,
            disabled: !surveyTypeIsValidForContext
        }} />;
};

